export default __webpack_public_path__ + "static/media/Siddika.b26dcb74.png";